import {SpotLayer} from './SpotLayer.js';
import {Modal} from './Modal.js';
import {getAvitoHtml, setDescriptionEvents, getJson, multiplyVectors} from '../helpers.js';

var self;

var clickSelected = '';
var hoverSelectedName = '';
var hoverSelectedFeature = null;

//================= AUTH =================
const getParams = (new URL(document.location)).searchParams; 
const appMK = getParams.get("mk");
const proxyURL = 'https://map.rentspb.ru/spotmap/prx/?' + (appMK !== null ? 'mk='+appMK+'&' : '');

const appUser = 'cornil';
const appKey = 'test_key';



//Create an overlay to anchor the popup to the map
const targetDiv = document.getElementById('target');
const leftContent = document.getElementById('obj-popup-content');
const leftContainer = document.getElementById('obj-popup');

var filters = {};

var loadingID = '';
var rotationRad = 0;
var startTime = new Date().getTime();

var enabledMarkerTypes = [1,1,1,1,1];

var subLayerRadio = null;		//for checking addEventListener

const svgArrowDown = '<svg height="200px" width="200px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-51.2 -51.2 614.40 614.40" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#fffafa" stroke-width="45.056"> <style type="text/css"> .st0{fill:#4c6c8a;} </style> <g> <polygon class="st0" points="358.402,195.5 358.402,0 153.598,0 153.598,195.5 18.616,195.5 255.991,512 493.384,195.5 "></polygon> </g> </g><g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0{fill:#4c6c8a;} </style> <g> <polygon class="st0" points="358.402,195.5 358.402,0 153.598,0 153.598,195.5 18.616,195.5 255.991,512 493.384,195.5 "></polygon> </g> </g></svg>';



export class AvitoLayer extends SpotLayer {
	constructor(options){
		var sw_avito_view = 'sw0';
		//var title = '</label><div class="sw_avito_title">Avito <= 220k ₽';
		var html = '<div class="avito_filter_btn" title="Фильтр" aria-label="Фильтр">[<span id="filter_link">фильтр</span>]</div><div class="sw_avito">';
		html += '<span><input id="sw_avito_type0" class="sw_btn" type_id="0" type="radio" name="sw_avito"'+((sw_avito_view == 'sw0') ? ' checked="checked"' : "")+'><label for="sw_avito_type0" class="item_type0">Все</label></span> ';
		html += '<span><input id="sw_avito_type2" class="sw_btn" type_id="2" type="radio" name="sw_avito"'+((sw_avito_view == 'sw2') ? ' checked="checked"' : "")+'><label for="sw_avito_type2" class="item_type2">Только новые</label></span> ';
		html += '<span><input id="sw_avito_type1" class="sw_btn" type_id="1" type="radio" name="sw_avito"'+((sw_avito_view == 'sw1') ? ' checked="checked"' : "")+'><label for="sw_avito_type1" class="item_type1">Объекты в работе</label></span> ';
		html += '<span><input id="sw_avito_type3" class="sw_btn" type_id="3" type="radio" name="sw_avito"'+((sw_avito_view == 'sw3') ? ' checked="checked"' : "")+'><label for="sw_avito_type3" class="item_type3">Запросить план</label></span> ';
		html += '<span><input id="sw_avito_type4" class="sw_btn" type_id="4" type="radio" name="sw_avito"'+((sw_avito_view == 'sw4') ? ' checked="checked"' : "")+'><label for="sw_avito_type4" class="item_type4">Интересные</label></span> ';
		html += '</div>';

		options.source = new ol.source.Vector();
		options.html = html;
		filters = options.filters;
		
		super(options);
		self = this;

		this.modal = new Modal({
			title: 'Фильтры Авито',
			html: `<span><b>Действующий фильтр:</b><br />площадь: от ${filters.areaMin} до ${filters.areaMax} м<sup>2</sup><br />цена: от ${filters.priceMin} до ${filters.priceMax} ₽ в месяц<br /> первый этаж, не цоколь, не подвал, прямая аренда, вход с улицы, свободного назначения, общепит, торговая площадь.</span>`,
		});

		this.overlay = new ol.Overlay({
			element: targetDiv,
			//element: container,
			autoPan: true,
			autoPanAnimation: {
				duration: 250
			},
		});
	}

//============================ /* STYLE */ ============================
	styleFunc(feature, resolution){
		var props = feature.getProperties();
		var name = feature.get('name');
//console.log(props);
		var zIndex = 100;
		props.stroke = '#fff';
		var typeArr = [0,0,0,0,0];
		var colorArr = ['#00f','rgba(0,0,255,0.2)','#f80','#f0f','#090'];

		switch (props.style) {
			case 'red':
				props.color = '#f00';
				colorArr[0] = '#f00';
				zIndex = zIndex+1;
				break;
			case 'brown':
				props.color = '#648dff';
				colorArr[0] = '#648dff';
				zIndex = zIndex-1;
				break;
			case 'default':
			default:
				props.color = '#00f';
		}

		var types = props.items_type;
		for (var key in types) {
			switch (types[key]) {

				case 0:
					//props.color = '#ddd';
					typeArr[0] = 1;
					break;
				case 1:
					props.color = 'rgba(0,0,255,0.2)';
					typeArr[1] = 1;
					zIndex = zIndex-2;
					break;
				case 2:
					props.color = '#f80';
					typeArr[2] = 1;
					break;
				case 3:
					props.color = '#f0f';
					typeArr[3] = 1;
					break;
				case 4:
					props.color = '#090';
					typeArr[4] = 1;
					break;
			}
		}

		var style = [];

		var scale = 1/Math.pow(resolution, 1/6);
		if ((hoverSelectedName === name) || (clickSelected === name)){
//		if ((false) || (clickSelected === name)){
			scale *= 1.5;
			zIndex = 10000;

			if (clickSelected === name){
				style.push(new ol.style.Style({
					style_id: 'loading',
					image: new ol.style.Icon({
						src: 'data:image/svg+xml;utf8,' + escape(svgArrowDown),
						anchor: [0.5, 1.15],
						scale: scale*0.3,
	/* 
						radius: 24,
						stroke: new ol.style.Stroke({
							color: 'rgba(0,0,0,0.5)',
							//color: props.stroke,
							width: 4,
						}),
	 */
					}),
					zIndex: zIndex+100,
				}));
			}
		}


		if(loadingID === name){
			style.push(new ol.style.Style({
				style_id: 'loading',
				image: new ol.style.Icon({
					//anchor: [0.5, 1],
					src: './loading-63.gif',
					scale: scale,
				}),
				zIndex: zIndex,
			}));
			//var elapsedTime = new Date().getTime() - startTime;
			//var rotation = elapsedTime / 5000 * Math.PI;
			//var rotation = new Date().getTime() / 1000;// * Math.PI;
			var rotation = rotationRad;// / 1000;// * Math.PI;
			style[0].getImage().setRotation(rotation);
		}

		feature.setProperties(props);

	//src: document.getElementById('loading_gif'),		//'./loading-63.gif',

		//console.log(this.multiplyVectors(typeArr, enabledMarkerTypes));
		//console.log(this);

		var enabledTypes = multiplyVectors(typeArr, enabledMarkerTypes);
		if (!enabledTypes.includes(1))return null;
		
		if (types.length == 1){
			style.push(new ol.style.Style({
				style_id: 'marker',
				image: new ol.style.Circle({
					radius: 12,
					stroke: new ol.style.Stroke({
						color: props.stroke,
						width: 4,
					}),
					fill: new ol.style.Fill({
						color: props.color,
					}),
					scale: scale,
				}),
				zIndex: zIndex,
			}));
		} else {
			style.push(new ol.style.Style({
				style_id: 'marker',
				image: new ol.style.Chart({
					type: 'pie',
					colors: colorArr,
					radius: 14,
					data: typeArr,
					stroke: new ol.style.Stroke({
						color: props.stroke,
						width: 3,
					}),
					scale: scale,
				}),
				zIndex: zIndex,
			}));
		}

		return style;
	}



	restyleAll(){
		var features = this.getSource().getFeatures();
		features.forEach((feature) => {
			feature.setStyle(feature.styleFunc);
		});
	}


//============================ /* STYLE */ ============================

//========================== /* SUBLAYERS */ ==========================

	changeSubLayer(event){
		var objID = event.target.getAttribute("type_id");
		switch (objID){
			case '0':
			enabledMarkerTypes = [1,1,1,1,1];		// show all
			self.setMapBlur(false);
			break;
			case '1':
			enabledMarkerTypes = [0,0,1,1,1];		// in process
			self.setMapBlur(true);
			break;
			case '2':
			enabledMarkerTypes = [1,0,0,0,0];		// only new
			self.setMapBlur(false);
			break;
			case '3':
			enabledMarkerTypes = [0,0,0,1,0];		// request plan
			self.setMapBlur(true);
			break;
			case '4':
			enabledMarkerTypes = [0,0,1,0,1];		// interesting
			self.setMapBlur(true);
			break;
		}
		//console.log(enabledMarkerTypes);
		self.restyleAll();
	}
	
	setMapBlur(doBlur = false){
		var olLayers = document.getElementsByClassName('ol-layers')[0];
		if(doBlur){
			olLayers.classList.add('ol-blur');
		} else {
			olLayers.classList.remove('ol-blur');
		}
	}

//========================== /* SUBLAYERS */ ==========================

//======================== /* MOUSE EVENTS */ =========================

	hoverUnset(){
		if (hoverSelectedName !== '') {
			hoverSelectedName = '';
			hoverSelectedFeature.setStyle(this.styleFunc);
			hoverSelectedFeature = null;
		}
	}

	hoverFunc(feature){
		var name = feature.get('name');
		hoverSelectedName = name;
		hoverSelectedFeature = feature;
		hoverSelectedFeature.setStyle(this.styleFunc);
	}


	clickUnset(){
		leftContainer.style.display="none";
		targetDiv.style.display="none";
		if(clickSelected !== ''){
			var feature = this.getFeatureByName(clickSelected);
			clickSelected = '';
			feature.setStyle(this.styleFunc);
		}
	}

	async clickFunc(feature){
		var name = feature.get('name');


		var coordinate = feature.getGeometry().getCoordinates();
		targetDiv.innerHTML = this.getLoadingHtml('loading-63');
		this.overlay.setPosition(coordinate);
		targetDiv.style.display="block";

		clickSelected = name;
		feature.setStyle(this.styleFunc);

		leftContent.innerHTML = this.getLoadingHtml();
		leftContainer.style.display="flex";
		leftContent.innerHTML = await this.getAvitoInfo(name);

		targetDiv.style.display="none";
		setDescriptionEvents();

		var radios = document.querySelectorAll('input[type=radio][class="types_btn"]');
		radios.forEach(el => el.addEventListener('change', event => {
			this.changeHandler(event);
		}));
	}
	
	//====== filterClick ======
	filterClick(){
		//console.log(self.modal);
		self.modal.showModal();
	}
	
//======================== /* MOUSE EVENTS */ =========================



	async getAvitoInfo(name){
		var tmpArr = name.split(',');
		for(var i=0;i<tmpArr.length;i++){
			tmpArr[i]="ids["+i+"]="+tmpArr[i];
		}
		var ids = tmpArr.join('&');
		var url = encodeURI('https://www.avito.ru/js/1/map/pin/items?'+ids);

		var response = await getJson(proxyURL + `u=${appUser}&key=${appKey}&w=${btoa(url)}&r=info`);

		var result = '';
		for (var item in response.items) {
			if (item >0) {result += '<hr>';}
			result += getAvitoHtml(response.items[item]);
		}
		return(result);
	};
	
//------ types of objects ------
	changeHandler(event) {			// SET MARKER STYLE BY TYPE
		var objID = event.target.getAttribute("obj_id");
		var typeID = event.target.getAttribute("type_id");
		this.setFeatureTypeByObjID(objID, typeID);
	}
	setFeatureTypeByObjID(objID, typeID){
		var features = this.getSource().getFeatures();

		features.forEach((feature) => {
			var props = feature.getProperties();
			var ids = feature.get('name').split(',');
			for (var i = 0; i < ids.length; i++) {
				if(ids[i] === objID){
					props.items_type[i] = Number(typeID);
					
					this.sendTypeToServer(objID, typeID);

					feature.setStyle(this.styleFunc);
					feature.setProperties(props);
					break;
				}
			}
		});
	}
	async sendTypeToServer(objID, typeID){
		var url = proxyURL + `u=${appUser}&key=${appKey}&r=set_type&id=${objID}&type=${typeID}`;
		var response = await getJson(url);
	}
//------------------------------

//=========== GET AVITO MARKERS ============
	async loadMarkers(mvp){

		if(subLayerRadio === null){				//addEventListener FOR CUSTOM LAYER SWITCHER
			subLayerRadio = document.querySelectorAll('input[type=radio][class="sw_btn"]');
			Array.prototype.forEach.call(subLayerRadio, function(radio) {
				radio.addEventListener('change', self.changeSubLayer);
			});
			
			document.getElementById('filter_link').addEventListener('click', self.filterClick);
			//document.getElementById('filter_link').addEventListener('click', function(){console.log('!!!');});
		}


		var aMap = btoa(`{"searchArea":{"latBottom":${mvp.latB},"latTop":${mvp.latT},"lonLeft":${mvp.lonL},"lonRight":${mvp.lonR}},"zoom":${mvp.zoom}}`);
		var filtersJson = btoa(`{"categoryId":42,"correctorMode":0,"directionId":[],"districtId":[],"from":"","localPriority":1,"locationId":653240,"map":"${aMap}","metroId":[],"page":5,"params":{"110799":[472647,472644,472643],"118807":[2308757],"118820":[2308779],"1210":13970,"1243":{"from":${filters.areaMin},"to":${filters.areaMax}},"146692":[3235941,3235942,3235940],"536":5546},"priceMin":${filters.priceMin},"priceMax":${filters.priceMax},"rootCategoryId":4,"searchArea":{"latBottom":${mvp.latB},"latTop":${mvp.latT},"lonLeft":${mvp.lonL},"lonRight":${mvp.lonR}},"verticalCategoryId":1,"viewPort":{"height":537,"width":2060}}`);
		var url = `https://www.avito.ru/web/1/map/markers?filters=${filtersJson}&offsetView%5Bleft%5D=500&z=${mvp.zoom}`;


		var json_url = proxyURL + `u=${appUser}&key=${appKey}&w=${btoa(url)}&r=m`;
		var response = await getJson(json_url);
		var markersInfo = response.info;


		this.getSource().clear();
		
		var tmpIds = [];
	/* 						// CHECK FOR DUPLICATE ITEMS
		for (var item in response.items) {
			if (tmpIds.indexOf(response.items[item].id)>=0){
				console.log(tmpIds.indexOf(response.items[item].id));
			} else {
				tmpIds.push(response.items[item].id);
			}
		}
		console.log(tmpIds);
		tmpIds = [];
	 */
		for (var item in response.items) {
			if (tmpIds.indexOf(response.items[item].id) == -1){
				tmpIds.push(response.items[item].id);
				var ids = response.items[item].id.split(',');
				var marker = new ol.Feature({
					geometry: new ol.geom.Point(ol.proj.fromLonLat([response.items[item].coords.lng, response.items[item].coords.lat])),
					style: 'default',
					name: response.items[item].id,
				});
				var props = marker.getProperties();
				if (Math.max.apply(null, ids) >= markersInfo.last20p){
					props.style = 'red';
				}
				if (Math.max.apply(null, ids) <= markersInfo.old20p){
					props.style = 'brown';
				}
				//props.items_type = response.items[item].items_type;
				props.items_type = response.items[item].type_ids;
				props.comments = response.items[item].comments;		// TODO
				marker.setProperties(props);
				marker.styleFunc = this.styleFunc;
				marker.setStyle(this.styleFunc);
				//avitoLayers['type'+0].getSource().addFeature(marker);
				this.getSource().addFeature(marker);
			}
		}
	}
//==========================================

	

}